// Module
var code = "<div class=\"scroll-div\" ref=\"scrollDiv\">\n    <div class=\"thumb\" ref=\"thumb\">\n    </div>\n</div>";
// Exports
module.exports = code;